import { type FC, useCallback, useMemo, useState } from 'react';

import { Popover } from '../../../../atoms';
import { DataFreshnessDetailsSheet } from '../data-freshness-sidesheet';
import {
  type DatasetsDataFreshnessStatus,
  type GeneratedDataFreshnessDataset,
  type UploadedDataFreshnessDataset,
} from '../DataFreshnessWidget.types';
import { DataFreshnessWidgetTooltip } from '../DataFreshnessWidgetTooltip';

import { DataFreshnessPopoverContent } from './data-freshness-popover-content';
import { DataFreshnessNavButton } from './DataFreshnessNavButton';
import { SeeDetailsButton } from './SeeDetailsButton';
import { getOldestDataset } from './utilities';

interface DataFreshnessPopoverProps {
  dataFreshnessStatus: DatasetsDataFreshnessStatus;
  uploadedDatasets: UploadedDataFreshnessDataset[];
  generatedDatasets: GeneratedDataFreshnessDataset[];
}

export const DataFreshnessPopover: FC<DataFreshnessPopoverProps> = ({
  dataFreshnessStatus,
  uploadedDatasets,
  generatedDatasets,
}) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [isDetailsSheetOpen, setIsDetailsSheetOpen] = useState(false);

  const handleSeeDetails = useCallback(() => {
    setIsPopoverOpen(false);
    setIsDetailsSheetOpen(true);
  }, []);

  const oldestUploadedDataset = useMemo(
    () => getOldestDataset(uploadedDatasets),
    [uploadedDatasets],
  );

  const oldestUploadedAgeDays = oldestUploadedDataset?.ageDays ?? null;

  return (
    <>
      <DataFreshnessWidgetTooltip show={!isPopoverOpen && !isDetailsSheetOpen}>
        <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
          <DataFreshnessNavButton
            status={dataFreshnessStatus}
            ageDays={oldestUploadedAgeDays}
          />
          <DataFreshnessPopoverContent
            uploadedDatasets={uploadedDatasets}
            generatedDatasets={generatedDatasets}
          >
            <SeeDetailsButton onClick={handleSeeDetails} />
          </DataFreshnessPopoverContent>
        </Popover>
      </DataFreshnessWidgetTooltip>
      <DataFreshnessDetailsSheet
        isOpen={isDetailsSheetOpen}
        setIsOpen={setIsDetailsSheetOpen}
        uploadedDatasets={uploadedDatasets}
        generatedDatasets={generatedDatasets}
        dataFreshnessStatus={dataFreshnessStatus}
      />
    </>
  );
};
